import { PORTAL_ROUTE } from 'src/constants/routes';

const fmt = (value, loading) => (loading ? '...' : value ?? 0);

export const deviceTabs = (deviceId, counts = {}, loading = false) => [
  {
    label: 'General',
    value: `${PORTAL_ROUTE}/devices/${deviceId}/general`,
  },
  {
    label: `Win32 Apps (${fmt(counts.win32AppsCount, loading)})`,
    value: `${PORTAL_ROUTE}/devices/${deviceId}/win32-apps`,
  },
  {
    label: `Packaged Apps (${fmt(counts.packagedAppCount, loading)})`,
    value: `${PORTAL_ROUTE}/devices/${deviceId}/packaged-apps`,
  },
  {
    label: `Unmatched Files (${fmt(counts.unmatchedFilesCount, loading)})`,
    value: `${PORTAL_ROUTE}/devices/${deviceId}/unmatched-files`,
  },
  {
    label: `Policy (${fmt(counts.policyCount, loading)})`,
    value: `${PORTAL_ROUTE}/devices/${deviceId}/policy`,
  },
  {
    label: `Managed Installers (${fmt(counts.managedInstallersCount, loading)})`,
    value: `${PORTAL_ROUTE}/devices/${deviceId}/managed-installers`,
  },
  {
    label: `Security Catalogs (${fmt(counts.catalogsCount, loading)})`,
    value: `${PORTAL_ROUTE}/devices/${deviceId}/catalog-inventory`,
  },
  {
    label: `Script Execution (${fmt(counts.scriptExecutionsCount, loading)})`,
    value: `${PORTAL_ROUTE}/devices/${deviceId}/script-execution`,
  },
  {
    label: `Logs (${fmt(counts.logsCount, loading)})`,
    value: `${PORTAL_ROUTE}/devices/${deviceId}/logs`,
  },
];

export const DEVICES_PREVIOUS_PATH = 'devicesPreviousPath';
